const graficoFundoRotativo = (context, dados) => {
  let anoSelecionado = dados.anos.length-1;
  return{
    data: {
      seriesRateioCooperado: [{
        name: 'Rateio Anual do Cooperado',
        data: dados.vl_rateio_cooperado
      }],
      chartOptionsRateioCooperado: {
        chart: {
          toolbar: {
            show: false,
          },
          events: {
            dataPointSelection: function(chartContext, seriesIndex, config) {
              if(anoSelecionado != config.dataPointIndex){
                anoSelecionado = config.dataPointIndex
                context.passaDados(config.dataPointIndex);
              } else {
                return
              }
            },
          }
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
              return parseFloat(val).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
          },
          offsetY: -22,
          style: {
            fontSize: '12px',
          }
        },
        colors: ['#f46a6a'],
        xaxis: {
          categories: dados.anos,
          position: 'bottom',
        },

        yaxis: {
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false,
            },
            labels: {
                show: false,
                formatter: function (val) {
                    return val + "%";
                }
            }
        },
      },

      seriesRemuneracao: [{
        name: 'Remuneração Anual do Cooperado',
        data: dados.vl_remunera
      }],
      chartOptionsRemuneracao: {
        chart: {
          toolbar: {
            show: false,
          },
          events: {
            dataPointSelection: function(chartContext, seriesIndex, config) {
              if(anoSelecionado != config.dataPointIndex){
                anoSelecionado = config.dataPointIndex
                context.passaDados(config.dataPointIndex);
              } else {
                return
              }
            },
          }
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
              return parseFloat(val).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
          },
          offsetY: -22,
          style: {
            fontSize: '12px',
          }
        },
        colors: ['#556ee6'],
        xaxis: {
          categories: dados.anos,
          position: 'bottom',
        },

        yaxis: {
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false,
            },
            labels: {
                show: false,
                formatter: function (val) {
                    return val + "%";
                }
            }
        },
      },

      seriesRateioGlobal: [{
        name: 'Sobra Global Disponível ',
        data: dados.vl_rateio_global
      }],
      chartOptionsRateioGlobal: {
        chart: {
          toolbar: {
            show: false,
          },
          events: {
            dataPointSelection: function(chartContext, seriesIndex, config) {
              if(anoSelecionado != config.dataPointIndex){
                anoSelecionado = config.dataPointIndex
                context.passaDados(config.dataPointIndex);
              } else {
                return
              }
            },
          }
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return parseFloat(val).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
          },
          offsetY: -22,
          style: {
            fontSize: '12px',
          }
        },
        colors: ['#34c38f'],
        xaxis: {
          categories: dados.anos,
          position: 'bottom',
        },

        yaxis: {
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false,
            },
            labels: {
                show: false,
                formatter: function (val) {
                  return parseFloat(val).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
                }
            }
        },
      }
    }
  }
};
export { graficoFundoRotativo};